import { createAction } from '@reduxjs/toolkit'

export const clearAll = createAction('clearAll')

export const clearAccount = createAction('clearAccount')
